<template>
  <div>
    <div
      style="display: flex; flex-wrap: wrap; justify-content: center !important"
    >
      <div class="content">
        <!-- <div>
          <a class="a-top">库存叉车</a>
          <a class="a-top">前面四轮</a>
          <a class="a-top">电动搬用车</a>
          <a class="a-top">LINDE</a>
        </div> -->
        <a-row>
          <a-col :xs="24" :sm="24" :md="24" :lg="24">
            <div
              style="
                font-size: 1rem !important;
                font-weight: 700 !important;
                margin-top: 20px;
                margin-bottom: 10px;
              "
            >
              <span style="color: #0067b3">{{ forkLiftData.code }}</span>
              {{ forkLiftData.model }} {{ forkLiftData.brand }}
            </div>
          </a-col>
        </a-row>

        <a-row>
          <a-col :xs="24" :sm="24" :md="12" :lg="12">
            <div>
              <div>
                <div class="layoutHeaderRs_footIamgs1 image-container">
                  <a-carousel arrows autoplay>
                    <div
                      slot="prevArrow"
                      class="custom-slick-arrow"
                      style="left: 10px; z-index: 1"
                    >
                      <a-icon type="left-circle" />
                    </div>
                    <div
                      slot="nextArrow"
                      class="custom-slick-arrow"
                      style="right: 10px"
                    >
                      <a-icon type="right-circle" />
                    </div>

                    <img
                      v-for="(it, i) in imgs.length > 0 ? imgs : [img]"
                      :key="i"
                      :src="it"
                    />

                    <!-- <div class="image-container">
                    <img
                      width="100%"
                      height="210px"
                      :src="record.pic ? record.pic : img"
                      alt=""
                      class="img1"
                    />

                    <div class="icon">
                      <div>
                        <div
                          class="icon-div1"
                          v-for="(item, index) in record.tags"
                          :key="index"
                          :style="{ background: item.color, color: 'white' }"
                        >
                          {{ item.tag }}
                        </div>
                      </div>
                    </div>
                  </div> -->
                  </a-carousel>
                  <div class="icon">
                    <div>
                      <div
                        class="icon-div1"
                        v-for="(item, index) in forkLiftData.tags"
                        :key="index"
                        :style="{ background: item.color, color: 'white' }"
                      >
                        {{ item.tag }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- <img
                width="100%"
                height="600px"
                :src="imgs[0] ? imgs[0] : img"
                alt=""
                class="img1"
              /> -->
            </div>
          </a-col>
          <a-col :xs="24" :sm="24" :md="12" :lg="12">
            <div class="rightCard">
              <a-row
                class="div-row bg-white marginBottom"
                style="padding-top: 15px; padding-bottom: 15px"
              >
                <a-col :xs="12" :sm="12" :md="6" :lg="4">
                  <div class="text-center">
                    <img width="40px" src="../img/rili.png" alt="" />
                    <div>{{ $t("车辆详情.生产年份") }}</div>
                    <div>{{ forkLiftData.factoryDate }}</div>
                  </div>
                </a-col>
                <a-col :xs="12" :sm="12" :md="6" :lg="4">
                  <div class="text-center">
                    <img width="40px" src="../img/shandian.png" alt="" />
                    <div>{{ $t("车辆详情.动力方式") }}</div>
                    <div>{{ forkLiftData.动力方式 }}</div>
                  </div>
                </a-col>
                <a-col :xs="12" :sm="12" :md="6" :lg="4">
                  <div class="text-center">
                    <img width="40px" src="../img/zhongliang.png" alt="" />
                    <div>{{ $t("车辆详情.负载能力") }}</div>
                    <div>
                      {{ parseStringToNumber(forkLiftData.载重能力) }}kg
                    </div>
                  </div>
                </a-col>
                <a-col :xs="12" :sm="12" :md="6" :lg="4">
                  <div class="text-center">
                    <img width="40px" src="../img/xiangao.svg" alt="" />
                    <div>{{ $t("车辆详情.提升高度") }}</div>
                    <div>
                      {{ parseStringToNumber(forkLiftData.货叉最大升高) }}mm
                    </div>
                  </div>
                </a-col>
                <a-col :xs="12" :sm="12" :md="6" :lg="4">
                  <div class="text-center">
                    <img width="40px" src="../img/shizhong.png" alt="" />
                    <div>{{ $t("车辆详情.工作小时数") }}</div>
                    <div>
                      {{ parseStringToNumber(forkLiftData.购入时工时) }}h
                    </div>
                  </div>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <div
                    v-if="Object.keys(this.$store.state.userInfo).length <= 0"
                    style="
                      display: flex;
                      width: 100%;
                      align-items: center;
                      padding-left: 20px;
                      padding-top: 15px;
                      padding-bottom: 15px;
                    "
                    class="bg-white marginBottom"
                  >
                    <span style="font-size: 18px">{{
                      $t("车辆详情.登录后查询价格")
                    }}</span>
                  </div>
                </a-col>
              </a-row>
              <a-row
                style="
                  width: 100%;
                  align-items: center;
                  padding-left: 20px;
                  padding-top: 15px;
                  padding-bottom: 15px;
                "
                class="bg-grey marginBottom"
              >
                <a-col :xs="24" :sm="24" :md="12" :lg="12">
                  <div>
                    <span style="font-size: 18px"
                      >{{ $t("车辆详情.如需帮助请拨打") }}!</span
                    >
                  </div>
                  <div>
                    <span style="font-size: 18px" class="text-call">
                      +13504428433</span
                    >
                  </div>
                </a-col>
                <a-col :xs="24" :sm="24" :md="12" :lg="12">
                  <a-button
                    @click="clickQuotation"
                    size="large"
                    style="background-color: #04af04 !important; color: white"
                    >{{ $t("车辆详情.查询") }}</a-button
                  >
                </a-col>
              </a-row>
              <videoModel ref="videoModel"></videoModel>
              <a-row style="padding-top: 35px; padding-bottom: 15px">
                <a-col :xs="12" :sm="12" :md="6" :lg="4" class="imgcol">
                  <div class="text-center" @click="playVideo(forkLiftData.id)">
                    <img width="40px" src="../img/bofang.png" alt="" />
                    <span>{{ $t("车辆详情.播放") }}</span>
                  </div>
                </a-col>

                <a-col :xs="12" :sm="12" :md="6" :lg="4" class="imgcol">
                  <div class="text-center" @click="share">
                    <img width="40px" src="../img/gongxiang.png" alt="" />
                    <span>{{ $t("车辆详情.分享") }}</span>
                  </div>
                </a-col>
                <a-col :xs="12" :sm="12" :md="6" :lg="4" class="imgcol">
                  <div class="text-center" @click="favourite">
                    <img
                      width="40px"
                      :src="
                        $store.state.favoriteList.filter(
                          (item) => item.id == forkLiftData.id
                        ).length > 0
                          ? require('../img/yishoucang.png')
                          : require('../img/shoucang.png')
                      "
                      alt=""
                    />

                    <span>{{ $t("车辆详情.收藏") }}</span>
                  </div>
                </a-col>
                <a-col :xs="12" :sm="12" :md="6" :lg="4" class="imgcol">
                  <div class="text-center" @click="compare">
                    <img
                      width="40px"
                      :src="
                        $store.state.bijiaoList.filter(
                          (item) => item.id == forkLiftData.id
                        ).length > 0
                          ? require('../img/yibijiao.png')
                          : require('../img/tianping.png')
                      "
                      alt=""
                    />
                    <span>{{ $t("车辆详情.比较") }}</span>
                  </div>
                </a-col>

                <a-col :xs="12" :sm="12" :md="6" :lg="4" class="imgcol">
                  <div class="text-center" @click="xiazaiClick">
                    <img width="40px" src="../img/dayin.png" alt="" />
                    <span>{{ $t("车辆详情.打印PDF") }}</span>
                  </div>
                </a-col>

                <a-col :xs="12" :sm="12" :md="6" :lg="4" class="imgcol">
                  <div class="text-center" @click="zipImgs">
                    <img width="40px" src="../img/xiazaitupian.svg" alt="" />
                    <span>{{ $t("车辆详情.下载图片") }}</span>
                  </div>
                </a-col>
              </a-row>
            </div>
          </a-col>
        </a-row>

        <a-row>
          <a-col :xs="24" :sm="24" :md="24" :lg="24">
            <div>
              <a-carousel arrows>
                <div
                  slot="prevArrow"
                  class="custom-slick-arrow"
                  style="left: 10px; z-index: 1"
                >
                  <a-icon type="left-circle" />
                </div>
                <div
                  slot="nextArrow"
                  class="custom-slick-arrow"
                  style="right: -20px"
                >
                  <a-icon type="right-circle" />
                </div>

                <div
                  v-for="(item, index) in arr"
                  :key="index"
                  v-viewer="{ movable: false }"
                >
                  <div
                    class="layoutHeaderRs_footIamgs"
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      width: 100%;
                    "
                  >
                    <img
                      v-for="(it, i) in item"
                      :key="i"
                      :src="it"
                      alt=""
                      class="carouselImg"
                    />
                  </div>
                </div>
              </a-carousel>
            </div>
          </a-col>
        </a-row>
        <a-row>
          <a-col :xs="24" :sm="24" :md="8" :lg="8">
            <a-card size="small" style="width: 100%" :bordered="false">
              <a></a>
              <template slot="title"
                ><a class="CardTitle">{{ $t("车辆详情.车辆参数") }}</a>
              </template>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.登记号") }}</span
                ><span style="float: right">{{ forkLiftData.code }}</span>
              </div>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.负载能力 公斤") }}</span
                ><span style="float: right"
                  >{{ parseStringToNumber(forkLiftData.载重能力) }}kg</span
                >
              </div>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.提升高度 毫米") }}</span
                ><span style="float: right"
                  >{{ parseStringToNumber(forkLiftData.货叉最大升高) }}mm
                </span>
              </div>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.叉车回落高度 毫米") }}</span
                ><span style="float: right"
                  >{{ parseStringToNumber(forkLiftData.叉车回落高度) }}mm</span
                >
              </div>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.阀路") }}</span
                ><span style="float: right">{{ forkLiftData.阀路 }}</span>
              </div>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.动力方式") }}</span
                ><span style="float: right">{{ forkLiftData.动力方式 }}</span>
              </div>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.生产年份") }}</span
                ><span style="float: right">{{
                  forkLiftData.factoryDate
                }}</span>
              </div>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.叉车自重") }}</span
                ><span style="float: right">{{ forkLiftData.叉车自重 }}</span>
              </div>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.电池情况") }}</span
                ><span style="float: right">{{ forkLiftData.电池情况 }}</span>
              </div>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.入库时间") }}</span
                ><span style="float: right">{{
                  forkLiftData.warehouseDate
                }}</span>
              </div>
            </a-card>
          </a-col>
          <a-col :xs="24" :sm="24" :md="8" :lg="8">
            <a-card size="small" style="width: 100%" :bordered="false">
              <a></a>
              <template slot="title"
                ><a class="CardTitle">{{ $t("车辆详情.车辆属性") }}</a>
              </template>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.属具类型") }}</span
                ><span style="float: right">{{ forkLiftData.属具类型 }}</span>
              </div>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.车辆类型") }}</span
                ><span style="float: right">{{ forkLiftData.车辆类型 }}</span>
              </div>
              <div class="rowStyle">
                <span>{{ $t("车辆详情.门架类型") }}</span
                ><span style="float: right">{{ forkLiftData.门架类型 }}</span>
              </div>
              <!-- <div class="rowStyle">
                <span>{{ $t("车辆详情.车架号") }}</span
                ><span style="float: right">{{ forkLiftData.车架号 }}</span>
              </div> -->
              <!-- <div class="rowStyle">
                  <span>{{ $t("车辆详情.车辆牌照号") }}</span
                  ><span style="float: right">{{
                    forkLiftData.车辆牌照号
                  }}</span>
                </div> -->
              <div class="rowStyle">
                <span>{{ $t("车辆详情.工作小时数") }}</span
                ><span style="float: right"
                  >{{ parseStringToNumber(forkLiftData.购入时工时) }}h</span
                >
              </div>
            </a-card>
          </a-col>
          <a-col :xs="0" :sm="0" :md="4" :lg="4"> </a-col>
          <a-col :xs="24" :sm="24" :md="4" :lg="4">
            <right-mode></right-mode>
          </a-col>
        </a-row>
        <div
          style="
            margin-top: 20px;
            margin-bottom: 10px;
            text-align: center;
            font-size: 30px;
          "
        >
          {{ $t("车辆详情.其他车辆") }}
        </div>
        <div style="margin-top: 20px; margin-bottom: 10px">
          <div>
            <a-carousel arrows :dots="false" :autoplay="false">
              <div
                slot="prevArrow"
                class="custom-slick-arrow"
                style="left: 10px; z-index: 1"
              >
                <a-icon type="left-circle" />
              </div>
              <div
                slot="nextArrow"
                class="custom-slick-arrow"
                style="right: -20px"
              >
                <a-icon type="right-circle" />
              </div>

              <div v-for="(item, index) in listArr" :key="index">
                <a-row type="flex" justify="space-around">
                  <a-col :span="colSpan" v-for="(it, i) in item" :key="i">
                    <fork-model
                      @getID="getID"
                      class="carouselImg1"
                      :record="it"
                    >
                    </fork-model>
                  </a-col>
                </a-row>
              </div>
            </a-carousel>
          </div>
        </div>
      </div>
    </div>
    <quotationDlg ref="quotationDlg"></quotationDlg>
    <a-modal
      v-model="loadingModalVisible"
      title="正在加载PDF"
      :footer="null"
      :maskClosable="false"
    >
      <p>请稍候，正在加载PDF文件...</p>
    </a-modal>
    <div style="display: none"><web_zcxs ref="web_zcxs" /></div>
  </div>
</template>

<script>
import RightMode from "../model/rightMode";
import forkModel from "../model/forkModel";
import axios from "axios";
// import util from "../utils/util";
import {
  getBucket,
  arr1To2,
  convertToOneDimensionToArray,
} from "../utils/util";
import quotationDlg from "../model/quotation";
import videoModel from "../model/videoModel.vue";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import Vue from "vue";
import web_zcxs from "./web_zcxs.vue";
Vue.use(Viewer);
export default {
  components: {
    RightMode,
    forkModel,
    quotationDlg,
    videoModel,
    web_zcxs,
  },
  data() {
    return {
      // isLogin: "0",
      forkLiftData: {},
      imgs: [],
      arr: [[]],
      list: [],
      listArr: [],
      img: require("../img/wtupian.png"),
      currentImage: "",
      loadingModalVisible: false,
      modalVisible: false,
      printVisible: false,
    };
  },
  computed: {
    colSpan() {
      const screenWidth = window.innerWidth;
      if (screenWidth >= 1200) {
        return 6; // 在大屏幕上显示6张图片
      } else if (screenWidth >= 992) {
        return 8; // 在中等屏幕上显示4张图片
      } else if (screenWidth >= 768) {
        return 12; // 在小屏幕上显示3张图片
      } else {
        return 24; // 在更小的屏幕上显示2张图片
      }
    },
  },
  mounted() {
    const id = this.$route.query.id;
    // this.isLogin = Object.keys(this.$store.state.userInfo).length;
    if (id) {
      window.scrollTo({
        top: 0,
        behavior: "instant", // 可选，设置为 'smooth' 可以平滑滚动
      });
      this.queryData(id);
      this.queryAction();
    } else {
      this.$router.push({
        path: "/forkliftList",
      });
    }
  },
  methods: {
    parseStringToNumber(str) {
      // 使用正则表达式替换掉不需要的字符
      // console.log("str===", str);
      if (!str) {
        return 0;
      }
      if (str == "无") {
        return 0;
      }
      const cleanedStr = str.replace(/[kKgGmMhH ]|无/g, "");

      // 尝试将清理后的字符串转换为数字
      const number = parseFloat(cleanedStr);

      // 检查转换是否成功
      if (isNaN(number)) {
        console.error("字符串无法转换为数字", str);
        return 0;
      }

      return number;
    },
    showFullScreen(index, i) {
      this.currentImage = this.imgs[index * 5 + i];
      this.modalVisible = true;
    },
    playVideo(id) {
      // this.$message.success("开始播放");
      this.$refs.videoModel.show({ id: id });
    },
    compare() {
      let arr = [];
      arr = this.$store.state.bijiaoList;
      //alert(this.$store.state.favoriteList);
      if (arr.filter((item) => item.id == this.forkLiftData.id).length <= 0) {
        arr.push(this.forkLiftData);
        this.$store.dispatch("setbijiaoMessage", arr);
        localStorage.setItem("bijiaoJson", JSON.stringify(arr));
        //this.$refs.shoucang.src = require("../img/bofang.png");
        this.$message.info("加入比较成功");
      } else {
        this.$message.info("重复加入比较");
      }
    },
    login() {
      this.$router.push({ path: "/Login" });
    },
    favourite() {
      let arr = [];
      arr = this.$store.state.favoriteList;
      //alert(this.$store.state.favoriteList);
      if (arr.filter((item) => item.id == this.forkLiftData.id).length <= 0) {
        arr.push(this.forkLiftData);
        this.$store.dispatch("setFavoriteMessage", arr);
        localStorage.setItem("favoriteJson", JSON.stringify(arr));
        //this.$refs.shoucang.src = require("../img/bofang.png");
        this.$message.info("收藏成功");
      } else {
        this.$message.info("重复收藏");
      }
    },
    zipImgs() {
      // console.log(this.imgs, "45");
      const promises = [];
      const zip = new JSZip();

      console.log(999);
      this.imgs.forEach((item, index) => {
        const promise = axios({
          url: item,
          methos: "get",
          responseType: "blob",
        }).then((res) => {
          console.log(res);
          zip.file(`${index}.png`, res.data, { binary: true });
        });
        promises.push(promise);
      });

      Promise.all(promises).then(() => {
        zip
          .generateAsync({
            type: "blob",
            compression: "DEFLATE", // STORE: 默认不压缩， DEFLATE：需要压缩
            compressionOptions: {
              level: 9, // 压缩等级 1~9   1 压缩速度最快， 9 最优压缩方式
            },
          })
          .then((res) => {
            console.log(res, "allp");
            saveAs(res, `图片导出.zip`);
          });
      });
    },
    xiazaiClick() {
      if (Object.keys(this.$store.state.userInfo).length == 0) {
        this.$router.push({ path: "/login" });
        return;
      }
      console.log(this.forkLiftData.id, "forkLiftData");
      this.$refs.web_zcxs.print({
        assetID: this.forkLiftData.id,
        customerCompany: this.$store.state.userInfo.company,
        tableName: "jf_asset_info",
      });
      this.printVisible = false;
      // this.loadingModalVisible = true;
      // axios({
      //   url: this.$apiUrl + "/api/webCreatePDF",
      //   method: "POST",
      //   data: {
      //     assetID: this.forkLiftData.id,
      //     customerCompany: this.$store.state.userInfo.company,
      //   },
      // }).then((res) => {
      //   console.log(res, "resss");
      //   const blob = new Blob([new Uint8Array(res.data.url.data)], {
      //     type: "application/pdf",
      //   });
      //   saveAs(blob, `${this.forkLiftData.code}.pdf`);

      //   // let url = "https://" + res.data.url;
      //   // // console.log(url, "789456qianduan");
      //   this.loadingModalVisible = false;
      //   // window.open(url, "_blank");
      // });
    },
    share() {
      navigator.clipboard.writeText(window.location.href);
      this.$message.success("当前车辆信息复制成功!");

      // try {
      //   if (navigator.clipboard && window.isSecureContext) {
      //     navigator.clipboard.writeText(window.location.href);
      //   } else {
      //     const textArea = document.createElement("textarea");
      //     textArea.value = window.location.href;
      //     textArea.style.position = "absolute";
      //     textArea.style.opacity = "0";
      //     textArea.style.left = "-999999px";
      //     textArea.style.top = "-999999px";
      //     document.body.appendChild(textArea);
      //     textArea.focus();
      //     textArea.select();
      //     if (!document.execCommand("copy")) {
      //       throw new Error("Copy command failed");
      //     }
      //     textArea.remove();
      //   }
      //   this.$message.success("当前车辆信息复制成功!");
      // } catch (error) {
      //   console.error("复制失败：", error);
      //   this.$message.error("复制失败：!");
      // }
    },

    async getImg(addr, id) {
      this.imgs = await getBucket(addr, id);
      this.arr = arr1To2(this.imgs, 5);
    },

    getID(id) {
      this.queryData(id);
      this.queryAction();
    },
    queryAction() {
      axios
        .post(this.$apiUrl + "/api/general/queryAction", {
          actionName: "getAssetReport",
          filters: {
            queryFilter: [
              {
                dataIndex: "type",
                operator: "eq",
                value: "车辆设备",
              },
              {
                dataIndex: "stateMsg",
                operator: "eq",
                value: "在库",
              },
            ],
          },
          orderBy: [
            {
              field: "reportTime",
              order: "desc",
            },
          ],
          offset: 0,
          limit: 20,
        })
        .then((res) => {
          // console.log(res);

          this.list = res.data.data.map((item) => {
            item.assetConfig.split(";").forEach((obj) => {
              const e = obj.split(":");
              item[e[0]] = e[1];
            });
            return {
              ...item,
            };
          });

          this.listArr = arr1To2(this.list, 24 / this.colSpan);
          console.log("this.listArr=========", this.listArr);
        });
    },
    queryData(id) {
      axios({
        url: this.$apiUrl + "/api/general/querySingle",
        method: "POST",
        data: {
          tableName: "jf_asset_info",
          id: id,
        },
      }).then((res) => {
        //console.log("res.data=======", res.data);

        res.data.data.assetConfig.split(";").forEach((obj) => {
          const e = obj.split(":");
          res.data.data[e[0]] = e[1];
        });
        this.forkLiftData = res.data.data;

        this.forkLiftData.tags = JSON.parse(res.data.data.tags);

        console.log("res.data.data.id=======", res.data.data.id);
        this.getImg("basic/", res.data.data.id);
      });
    },
    clickQuotation() {
      // if (Object.keys(this.$store.state.userInfo).length != 0) {
      this.$refs.quotationDlg.show({
        type: "forkDetail",
        record: this.forkLiftData,
        id: this.forkLiftData.id,
      });
      // } else {
      //   this.$router.push({ path: "/login" });
      // }
    },
  },
};
</script>

<style scoped>
.imgcol {
  padding: 5px;
}
.gallery-row {
  margin: -8px;
}

.gallery-col {
  margin-bottom: 16px;
}

.gallery-col:last-child {
  margin-bottom: 0;
}

.a-card-cover img {
  width: 100%;
  height: auto;
  display: block;
  border-radius: 4px 4px 0 0;
}
.image-container {
  position: relative; /* 相对定位，使内部absolute定位的元素相对于此容器定位 */
  display: inline-block; /* 使div像inline-element一样表现，便于内部元素的定位 */
  width: 100%;
}

.image-container img {
  display: block; /* 防止图片下方出现空隙 */
  width: 100%; /* 或其他宽度 */
}

.img1 {
  object-fit: cover; /* 不会变形，但可能裁剪图片 */
}
.image-container .icon {
  position: absolute; /* 绝对定位 */
  top: 5px; /* 定位到图片的顶部 */
  right: 0px; /* 定位到图片的右侧 */
  font-size: 20px; /* 图标大小 */
  font-size: 12px; /* 标签字体大小 */
}
.icon-div1 {
  display: flex;
  font-size: 12px;
  font-weight: 700;
  color: black;
  justify-content: center;
  align-items: center;
  width: 100px;
  height: 30px;

  margin-bottom: 5px;
  clip-path: polygon(
    10% 0%,

    100% 0%,
    100% 100%,
    100% 100%,
    10% 100%,
    0% 50%
  );
}
.r1-svg {
  width: 2.5rem !important;
  color: white !important;
  fill: white !important;
}
.r1-span {
  font-size: 2.5rem !important;
  margin-right: 1rem !important;
}
.r2-div {
  font-size: 20px;
  text-align: center;
  margin-top: 3rem !important;
  background: #04af04 !important;
  color: white !important;
  font-weight: 700 !important;
}
.r1-1-Btn {
  margin-top: 20px;
  font-size: 1.25rem;
  padding: 1rem 0.5rem;
  width: 100%;
  height: auto;
}
.r1-1-div {
  color: #ff890a !important;
  padding-right: 0.5rem !important;
  margin-bottom: 1rem !important;
  margin-top: 1rem !important;
}
.r1-div {
  font-size: 18px;
  font-weight: 700 !important;
  text-align: center;
  padding: 3rem !important;
  border: 1px solid black;
}
.img1 {
  object-fit: cover; /* 不会变形，但可能裁剪图片 */
}
.layoutfork {
  flex: 2.5;
  height: auto;
  margin-left: 1.2rem;
  margin-bottom: 1.5rem;
  cursor: pointer;
}
.CardTitle {
  color: #0067b3;
  font-size: 20px;
  padding-bottom: 12px;
}
.rowStyle {
  border-bottom: 1px solid #f2f3f3;
  padding-top: 10px;
  padding-right: 5px;
  padding-left: 5px;
  padding-bottom: 10px;
}
.ant-carousel .slick-next::before {
  content: "";
}
.ant-carousel .slick-prev::before {
  content: "";
}
.ant-carousel >>> .slick-slide {
  text-align: center;
  height: auto;
  line-height: auto;
}

.ant-carousel >>> .custom-slick-arrow {
  width: 55px;
  height: 55px;
  font-size: 50px;
  color: #ececec;
}
.ant-carousel >>> .custom-slick-arrow:hover {
  opacity: 0.5;
  color: #0067b3;
}
.carouselImg {
  width: 18%;
  height: auto;
}
.carouselImg1 {
  width: 100%;
  height: 100%;
}

.layoutHeaderRs_footIamgs {
  width: 10rem;
  height: 10rem;

  cursor: pointer;
}
.layoutHeaderRs_footIamgs1 {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.layoutFootBottoms {
  width: 100vw;
  position: fixed;
  bottom: 0;
}

.text-call {
  color: #04af04 !important;
  font-size: 2rem !important;
}
.content {
  width: 83.33333333%;
}
.a-top {
  color: #0067b3 !important;
  margin-right: 8px;
}
.rightCard {
  background-color: #f2f3f3;
  padding: 3rem !important;
  flex: 5;
}
.div-row {
  display: flex;
  justify-content: space-around;
  width: 100%;
  flex-wrap: wrap;
}
.text-center {
  text-align: center !important;
}
.bg-white {
  background: white !important;
}
.bg-grey {
  background: #ececec !important;
}
.marginBottom {
  margin-bottom: 20px;
}
</style>
